module.exports = __webpack_public_path__ + "img/DJI_0033-lazy.7788e2f8.jpg";